import { ActionType } from '../infrastructure/actionTypes';
import ImageService from '../services/ImageService';
import { IProductLogo } from '../infrastructure/interfaces';
import * as GoogleAnalyticsEvents from "../infrastructure/GoogleAnalyticsEvents";

export const getProductLogosList = () => {
    
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ImageService
      .getProductLogos()
      .then((productLogosList) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({ type: ActionType.GET_PRODUCT_LOGOS_DONE, productLogosList });
      })
      .catch(error => console.error(error));
  };
};

export const getProductIconsList = () => {
    
  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });
    ImageService
      .getProductIcons()
      .then((productIconsList) => {
        dispatch({ type: ActionType.STOP_LOADING });
        dispatch({ type: ActionType.GET_PRODUCT_ICONS_DONE, productIconsList });
      })
      .catch(error => console.error(error));
  };
};

export const updateProductLogo = (formData: FormData) => {

  return (dispatch: any) => {
    dispatch({ type: ActionType.START_LOADING });

    ImageService
      .uploadProductLogo(formData)
      .then((response: any) => {
        dispatch({ type: ActionType.STOP_LOADING });

        let logoData: IProductLogo = {
          id: (response.id as string)!,
          src: (response.file as string)!,
          archived: false,
        };
        dispatch({ type: ActionType.UPDATE_PRODUCT_LOGO_DONE, logoData});
        GoogleAnalyticsEvents.editProductLogo(logoData);
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/imageActions.ts